import axios, { AxiosInstance } from 'axios';

interface SaleForceData {
  email: string;
  phone: string;
  activation: string;
}

interface SalesforceResponse {
  status: string;
}

class SaleForceWebHook {
  private axiosInstance: AxiosInstance;
  private isProd: boolean;

  constructor() {
    const baseUrl = import.meta.env.VITE_APP_SALEFORCE_BASE_URL || '';

    this.axiosInstance = axios.create({
      baseURL: baseUrl
    });

    this.isProd = import.meta.env.VITE_APP_IS_PRODUCTION === 'true';
  }

  post(data: SaleForceData, sfResource: string = import.meta.env.VITE_APP_MEDBOX_PORTAL_RESOURCE): Promise<SalesforceResponse> {
    if (!sfResource) {
      return Promise.reject('Salesforce resource is not defined.');
    }

    return this.axiosInstance
      .post(sfResource, {
        email: data.email,
        phone: data.phone,
        activation: data.activation,
        env: this.isProd ? 'prod' : 'dev'
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }
}

const saleForceWebHookInstance = new SaleForceWebHook();
export default saleForceWebHookInstance;
